import React from "react";
import moment from "moment";

const companySizes = {
    micro: 'Microempresa (ME)',
    pequeno_porte: 'Pequeno porte (EPP)',
    demais: 'Médio ou grande porte',
};

const taxRegimes = {
    simples_nacional: 'Optante',
    mei: 'Optante (MEI)',
    normal: 'Não optante',
};

const statusTones = {
    Ativa: 'success',
    Suspensa: 'warning',
    Inapta: 'warning',
    Baixada: 'error',
    Nula: 'error',
};

export const receitaFromLookup = company => ({
    registration_status: company.situacao || null,
    opened_at: company.abertura || null,
    company_size: company.porte || null,
    tax_regime: company.regime || null,
    main_activity_code: company.cnae || null,
    main_activity_description: company.cnae_descricao || null,
});

export const receitaFromCompany = company => ({
    registration_status: company.registration_status ?? null,
    opened_at: company.opened_at ?? null,
    company_size: company.company_size ?? null,
    tax_regime: company.tax_regime ?? null,
    main_activity_code: company.main_activity_code ?? null,
    main_activity_description: company.main_activity_description ?? null,
});

const Item = ({label, children}) => (
    <div className="company-receita-summary__item">
        <span className="company-receita-summary__label">{label}</span>
        <span className="company-receita-summary__value">{children || '—'}</span>
    </div>
);

export const CompanyReceitaSummary = ({receita, checkedAt, pendingSave, compact, showEmpty, action}) => {
    const hasData = receita && Object.values(receita).some(Boolean);

    if (!hasData) {
        return showEmpty ? (
            <div className="company-receita-summary company-receita-summary--empty">
                <div className="company-receita-summary__header">
                    <span className="company-receita-summary__title">Receita Federal</span>
                    {action}
                </div>
                <p className="company-receita-summary__empty-text">
                    Ainda não consultada. A busca pelo CNPJ traz a situação cadastral, o porte, o Simples Nacional e a atividade principal.
                </p>
            </div>
        ) : null;
    }

    const status = receita.registration_status;
    const activity = [receita.main_activity_code, receita.main_activity_description].filter(Boolean).join(' · ');

    return (
        <div className={`company-receita-summary${compact ? ' company-receita-summary--compact' : ''}`}>
            <div className="company-receita-summary__header">
                <span className="company-receita-summary__title">Receita Federal</span>
                <div className="company-receita-summary__header-right">
                    {pendingSave &&
                        <span className="company-receita-summary__meta">Consultado agora · salve para guardar</span>
                    }
                    {!pendingSave && checkedAt &&
                        <span className="company-receita-summary__meta">Consultado em {moment(checkedAt).format('DD/MM/YYYY')}</span>
                    }
                    {action}
                </div>
            </div>
            <div className="company-receita-summary__grid">
                <Item label={`Situação`}>
                    {status &&
                        <span className={`company-receita-summary__status company-receita-summary__status--${statusTones[status] ?? 'warning'}`}>
                            {status}
                        </span>
                    }
                </Item>
                <Item label={`Abertura`}>
                    {receita.opened_at && moment(receita.opened_at).format('DD/MM/YYYY')}
                </Item>
                <Item label={`Porte`}>{companySizes[receita.company_size]}</Item>
                <Item label={`Simples Nacional`}>{taxRegimes[receita.tax_regime]}</Item>
            </div>
            {activity &&
                <div className="company-receita-summary__activity">
                    <Item label={`Atividade principal`}>{activity}</Item>
                </div>
            }
        </div>
    );
}

export default CompanyReceitaSummary;
